import { on } from '@ngrx/store';

import dayjs from 'dayjs';
import { uniq } from 'lodash';
import { LoadingState } from 'src/app/utilities/state.util';

import { MS_ONE_SECOND } from '../../../time';
import { JobToolState, NewOpportunityCard } from '../../job-tool.reducer';

import { JobCreateCustomerActions } from '../job-create-customer/job-create-customer.actions';

import { JobTimelineActions } from './job-timeline-availability.actions';



export const jobTimelineReducers = [
    on(
        JobTimelineActions.movingDateSelected,
        JobCreateCustomerActions.movingDateSelected,
        (state: JobToolState, res): JobToolState => {
            return {
                ...state,
                movingDate: res.movingDate,
                callState: {
                    ...state.callState,
                    Availability: LoadingState.LOADING,
                },
            };
        },
    ),
    on(
        JobTimelineActions.timeSlotSelected,
        (state: JobToolState, { timeSlot }): JobToolState => {
            return {
                ...state,
                selectedTimeSlot: timeSlot,
            };
        },
    ),
    on(
        JobTimelineActions.timeSlotLoaded,
        (state: JobToolState, { timeSlot }): JobToolState => {
            return {
                ...state,
                selectedTimeSlot: timeSlot,
                availableTimeSlots: [ timeSlot ],
            };
        },
    ),
    on(JobTimelineActions.headerClicked, (state: JobToolState): JobToolState => {

        const collapsedNewOpportunityCards = { ...state.collapsedNewOpportunityCards };

        if (NewOpportunityCard.timelineAndAvailability in collapsedNewOpportunityCards) {
            delete collapsedNewOpportunityCards[NewOpportunityCard.timelineAndAvailability]
        } else {
            collapsedNewOpportunityCards[NewOpportunityCard.timelineAndAvailability] = true;
        }

        return {
            ...state,
            collapsedNewOpportunityCards,
        };
      }),
    on(JobTimelineActions.findAvailabilitySuccess, (state: JobToolState, { windows, timezone }): JobToolState => {

        let selectedTimeSlot = state.selectedTimeSlot;

        const availableTimeSlots = uniq(windows.flatMap((w) => w.startTimes))
            .map((t) => dayjs.tz(t * MS_ONE_SECOND, timezone).format('h:mm A'));

        if (!availableTimeSlots.includes(selectedTimeSlot)) {
            selectedTimeSlot = undefined;
        }

        return {
            ...state,
            availableTimeSlots,
            selectedTimeSlot,
            callState: {
                ...state.callState,
                Availability: LoadingState.LOADED,
            }
        }
    }),
] as const;
